import { defineStore } from 'pinia'

export const usePageDataStore = defineStore('pageData', {
  state: () => ({
    routeKey: '',
    news: null,
    art: null,
    page: null,
    topic: null,
  }),

  actions: {
    setRouteData(routeKey, data) {
      this.routeKey = routeKey
      this.news = data.news ?? null
      this.art = data.art ?? null
      this.page = data.page ?? null
      this.topic = data.topic ?? null
    },

    clear() {
      this.routeKey = ''
      this.news = null
      this.art = null
      this.page = null
      this.topic = null
    },
  },
})
